// An intersection observer for all elements with classes that start with "animate__".
// When visible in the viewport, the class "animate__animated" is added to the element.


const observerOptions = {
  threshold: 0.1  // Adjust the threshold as needed
};

// array of selectors to observe
// const selectors = [
//   "block-masthead-feature",
//   "block-testimonial-figure",
//   "block-homepage-header .nav-item",
//   "block-homepage-header .tab-content",
//   "block-rate-group .block-rate-group-rate",
//   "block-product-carousel .block-product",
//   "block-feature-group .block-feature",
//   "block-icon-band .block-icon-band-item",
//   "block-masthead:has(.block-masthead-background) .block-masthead-heading",
// ];

const observer = new IntersectionObserver(entries => {
  entries.forEach(entry => {

    let animation = entry.target.dataset.animate;

    if (entry.intersectionRatio > 0) {
      entry.target.classList.add('animate__' + animation);
      entry.target.classList.add('animate__animated');
    }
    // Uncomment this block if you want the animation to be removed when the element is not visible
    // else {
    //   entry.target.classList.remove('animate__' + animation);
    //   entry.target.classList.remove('animate__animated');
    // }
  });
}, observerOptions);

// Select all the elements in the selectors array
document.querySelectorAll('[data-animate]').forEach(element => {
  // If the width of the screen is greater than 100 characters, add the element to the observer
  if (document.documentElement.clientWidth > 200) {
    observer.observe(element);
  } else {
    // remove the data-animate attribute
    element.removeAttribute('data-animate');
  }
});
